var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('v-fade-transition',[(_vm.status === 'signed-out')?_c('sh-homepage',{ref:"homepage"}):_vm._e()],1),_c('v-fade-transition',[(_vm.status === 'signed-in')?_c('sh-signhero'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }